<div class="wrapper">
  <div class="main-panel" [class.sidebar-collapsed]="isSidebarCollapsed">
    <app-page-header></app-page-header>
    @if (showSideBar) {
      <div class="sidebar">
        <app-page-sidebar></app-page-sidebar>
      </div>
    }
    <main class="main-content">
      <!-- Recoverable Error State -->
      @if (hasRecoverableError) {
        <div class="alert alert-warning m-4" role="alert">
          <div class="d-flex align-items-center">
            <i class="bi bi-exclamation-triangle-fill me-3 fs-4"></i>
            <div class="flex-grow-1">
              <h5 class="alert-heading mb-1">Connection Issue</h5>
              <p class="mb-2">{{ errorDetails || 'We encountered a temporary issue loading your account data.' }}</p>
              <small class="text-muted">Your session is still active. This is likely a temporary network or backend issue.</small>
            </div>
            <button type="button" class="btn btn-warning ms-3" (click)="manualRetry()">
              <i class="bi bi-arrow-clockwise me-2"></i>Retry
            </button>
          </div>
        </div>
      }
      <!-- Verify-your-email reminder (#943): nothing is blocked until verified
           except inviting teammates and exporting reports. -->
      <app-email-verification-banner></app-email-verification-banner>
      <!-- MFA Enrollment Prompt Banner (grace mode: security.mfaEnforcement = 'prompt') -->
      @if (showMfaPromptBanner) {
        <div class="alert alert-info alert-dismissible d-flex align-items-center m-3 mb-0" role="status">
          <i class="fas fa-shield-alt me-3 fs-4" aria-hidden="true"></i>
          <div class="flex-grow-1">
            <strong>Protect your account with two-factor authentication.</strong>
            Add a second verification step to keep your data safe.
            <a [routerLink]="['/enroll-mfa']" class="alert-link ms-1">Set up two-factor authentication</a>
          </div>
          <button
            type="button"
            class="btn-close"
            aria-label="Dismiss two-factor authentication reminder"
            (click)="dismissMfaPromptBanner()"
          ></button>
        </div>
      }
      <!-- Low-Credit Alert Banner -->
      @if ((creditSummary$ | async); as cs) {
        @if (cs.monthlyAllotment > 0 && cs.totalAvailable <= (1 - cs.softAlertThreshold / 100) * cs.monthlyAllotment) {
          <div class="credit-low-banner" [class.credit-critical]="cs.totalAvailable <= (1 - cs.hardAlertThreshold / 100) * cs.monthlyAllotment" role="alert">
            <div class="credit-low-banner-inner">
              <i class="fas fa-coins credit-low-icon"></i>
              <div class="credit-low-text">
                <strong>{{ cs.totalAvailable <= (1 - cs.hardAlertThreshold / 100) * cs.monthlyAllotment ? 'Coins critically low' : 'Coins running low' }}</strong>
                — {{ cs.totalAvailable | number }} Coins remaining this cycle.
              </div>
              @if (!isPartnerCompany) {
                <a [routerLink]="['/dashboard/company']" [queryParams]="{ tab: 'sni-tokens' }" class="btn-cyber btn-cyber-sm btn-cyber-primary credit-low-cta">
                  <i class="fas fa-plus me-1"></i>Top Up
                </a>
              }
            </div>
          </div>
        }
      }
      <router-outlet></router-outlet>
      <app-page-footer></app-page-footer>
    </main>
  </div>
</div>

<app-cookie-notification></app-cookie-notification>
@if (spinnerShow) {
  <app-loader></app-loader>
}
<app-alert-modal class="d-none" #alertModal></app-alert-modal>

<!-- Floating Chatbot -->
<app-floating-chatbot></app-floating-chatbot>

<!-- TODO: REMOVE AFTER TESTING - Toast Container for testing purposes only -->
<!-- This toast container should be REMOVED before production deployment -->
<app-toast-container></app-toast-container>
<!-- END TODO: REMOVE AFTER TESTING -->
